import { useState } from "react";

import { Box, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

import EditorToolbar from "../editors/EditorToolbar";
import ListItem from "../elements/ListItem";

import RepModal from "../modals/RepModal";

const columns = [
  {
    name: "name",
    fieldType: "text",
  },
];

const Reps = ({ data, onAdd, onDelete }) => {
  const { getMessage } = useLocalization();

  const [openModal, setOpenModal] = useState(false);
  const [selectedRep, setSelectedRep] = useState(null);

  const handleAdd = () => {
    setOpenModal(true);
  };

  const handleNewRep = (rep) => {
    onAdd(rep);
  };

  const handleRepSelect = (rep) => {
    setSelectedRep(rep._id);
    setOpenModal(true);
  };

  const handleRepDelete = (rep) => {
    onDelete(rep);
  };

  return (
    <>
      <Box>
        <EditorToolbar onAdd={handleAdd} />
        <Box
          sx={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {Array.isArray(data) && data.length > 0 ? (
            data.map((rep) => (
              <ListItem
                record={rep}
                columns={columns}
                onClick={() => handleRepSelect(rep)}
              />
            ))
          ) : (
            <Typography>{getMessage("noRecords")}</Typography>
          )}
        </Box>
      </Box>

      <RepModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSave={handleNewRep}
        userId={selectedRep}
        onDelete={handleRepDelete}
      />
    </>
  );
};

export default Reps;
